/* =============================================================================
   galeria.js — La página Galería: filtros, entrada de las fotos y visor
   Hotel La Gruta · Arequipa · estilos: assets/css/rd-galeria.css (pared) y
   "GALERÍA" en assets/css/site.css (visor)

   REDISEÑO 2026-10-29 («Fotografías a distintos tamaños»): la composición
   ya no se calcula aquí. Cada foto (<figure class="gal-item">) trae en el
   HTML su columna, su ancho y su desfase sobre la rejilla de 12 columnas, y
   las fotos están agrupadas en cuatro paseos (<section class="gal-tema">:
   jardín, habitaciones, mesa, casa). Sin JS la pared se ve igual; solo no
   hay filtros (nacen con `hidden`) ni visor (el enlace abre la foto grande).

   FILTROS: cada tema lleva data-cat (hotel · habitaciones · gastronomia;
   jardín y casa son los dos «hotel»). Filtrar oculta los temas y las fotos
   de otra categoría; el visor recorre solo las fotos visibles, en el orden
   del documento.
   ============================================================================= */
(function () {
  'use strict';

  var pagina = document.getElementById('page-galeria');
  if (!pagina) return;
  var fotos = [].slice.call(pagina.querySelectorAll('.gal-item'));      // orden del documento
  var temas = [].slice.call(pagina.querySelectorAll('.gal-tema'));
  var grupo = pagina.querySelector('.gal-filtros');
  var botones = grupo ? [].slice.call(grupo.querySelectorAll('.gal-filtro')) : [];
  var QUIETO = matchMedia('(prefers-reduced-motion: reduce)');
  if (!fotos.length) return;
  if (grupo) grupo.hidden = false;

  /* ── Filtros ──────────────────────────────────────────────────────────── */
  var filtro = 'todas', secuencia = [];

  function pasa(el) { return filtro === 'todas' || el.dataset.cat === filtro; }
  function aplicar() {
    temas.forEach(function (t) { t.hidden = !pasa(t); });
    fotos.forEach(function (li) { li.hidden = !pasa(li); });
    secuencia = fotos.filter(function (li) { return !li.hidden; });
  }

  botones.forEach(function (b) {
    b.addEventListener('click', function (event) {
      if (b.dataset.filtro === filtro) return;
      filtro = b.dataset.filtro;
      botones.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      // El resultado cambia al pulsar. Solo entran las fotos que se ven;
      // no dejamos un filtro esperando a un timeout anterior.
      fotos.forEach(function (li) { if (window.HotelMotion) window.HotelMotion.stop(enlace(li)); });
      aplicar();
      var visible = secuencia.filter(function (li) {
        var r = li.getBoundingClientRect();
        return r.bottom > 0 && r.top < innerHeight;
      });
      visible.forEach(function (li) { li.classList.add('is-visto'); });
      if (window.HotelMotion) window.HotelMotion.enter(visible.map(enlace), event, { duration: 220, stagger: 24 });
    });
  });

  /* ── Entrada al hacer scroll ──────────────────────────────────────────── */
  if ('IntersectionObserver' in window && !QUIETO.matches) {
    pagina.classList.add('gal-anima');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visto'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    fotos.forEach(function (li) { io.observe(li); });
  }

  /* ── Visor ──────────────────────────────────────────────────────────────
     Transición de "Image Grid Effects", demo 1 (Codrops, MIT:
     tympanus.net/Development/ImageGridEffects), con sus tiempos y su curva:
     ABRIR · una copia de la miniatura vuela desde su sitio en la grilla hasta
             el tamaño y lugar de la foto grande (0,6 s, cubic-bezier(.5,1,.2,1))
             mientras un círculo oscuro crece desde la esquina OPUESTA a la
             foto y cubre la pantalla (0,4 s). Al aterrizar, la foto grande
             (1600px) aparece encima con un fundido de 0,2 s y la copia se va;
             el pie sube con 0,2 s de retraso y los botones aparecen al final.
     CERRAR · la foto vuelve a su hueco de la grilla (0,3 s) mientras el fondo
             se desvanece; si su hueco quedó fuera de pantalla (se navegó con
             las flechas), solo se desvanece.
     Diferencias con el original, a propósito: la copia es una caja con la
     foto en object-fit: cover, no un <img> escalado, porque nuestras
     miniaturas están recortadas y redondeadas; así el recorte y las esquinas
     se abren de a poco en vez de saltar. Con movimiento reducido no hay
     vuelo ni círculo: el visor aparece y desaparece sin animar. */
  var visor = document.getElementById('galVisor');
  var vImg = visor && visor.querySelector('.gal-visor-img');
  var vTxt = visor && visor.querySelector('.gal-visor-txt');
  var vNum = visor && visor.querySelector('.gal-visor-num');
  var vFig = visor && visor.querySelector('.gal-visor-fig');
  var fondo = visor && visor.querySelector('.gal-visor-fondo');
  var actual = 0, volverA = null, scrollY0 = 0, clon = null;
  // fase: '' | 'abriendo' | 'cerrando'. vuelta: invalida los callbacks de
  // una apertura que se canceló (cerrar con Esc mientras la foto vuela).
  var fase = '', vuelta = 0;
  var CURVA = 'cubic-bezier(0.5, 1, 0.2, 1)';

  function enlace(li) { return li.querySelector('.gal-link'); }
  function anima() { return !QUIETO.matches && (!window.HotelMotion || window.HotelMotion.allowed()) && typeof visor.animate === 'function'; }

  // La foto grande, entera dentro de la figura (descontando el pie) y nunca
  // más grande que su archivo. Medida explícita: el vuelo necesita conocer
  // el rectángulo final antes de que la foto termine de cargar.
  function medir() {
    var li = secuencia[actual];
    if (!li) return;
    var cs = getComputedStyle(vFig), pie = vFig.querySelector('.gal-visor-pie');
    var W = vFig.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var H = vFig.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - pie.offsetHeight - parseFloat(cs.rowGap || cs.gap || 0);
    var w = +li.dataset.w || 4, h = +li.dataset.h || 3;
    var k = Math.min(W / w, H / h, Math.min(1600, w) / w);
    vImg.style.width = Math.round(w * k) + 'px';
    vImg.style.height = Math.round(h * k) + 'px';
  }

  function mostrar(i) {
    var n = secuencia.length;
    if (!n) return;
    var antes = secuencia[actual];
    actual = (i + n) % n;
    var li = secuencia[actual], img = li.querySelector('img');
    // El hueco vacío en la grilla sigue a la foto que se ve: al cerrar, vuelve ahí.
    if (antes) antes.classList.remove('is-abierta');
    li.classList.add('is-abierta');
    vTxt.textContent = img.alt;
    vNum.textContent = (actual + 1) + ' / ' + n;
    medir();
    vImg.alt = img.alt;
    vImg.src = enlace(li).getAttribute('href');
    // Pasar de foto con el visor ya abierto: fundido corto al cargar.
    if (visor.classList.contains('listo') && anima()) {
      vImg.style.opacity = 0;
      cuandoCargue(vImg, function () { vImg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 250 }); vImg.style.opacity = ''; });
    }
    // Las vecinas, a la caché: pasar de foto no espera la descarga.
    [actual + 1, actual - 1].forEach(function (k) {
      var v = secuencia[(k + n) % n];
      if (v) new Image().src = enlace(v).getAttribute('href');
    });
  }

  function cuandoCargue(img, fn) {
    if (img.complete && img.naturalWidth) { fn(); return; }
    var listo = function () { img.removeEventListener('load', listo); img.removeEventListener('error', listo); fn(); };
    img.addEventListener('load', listo);
    img.addEventListener('error', listo);
  }

  function crearClon(src, r) {
    var c = document.createElement('div'), im = document.createElement('img');
    c.className = 'gal-visor-clon';
    im.src = src; im.alt = '';
    c.appendChild(im);
    c.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
    visor.appendChild(c);
    return c;
  }
  function marco(r, radio) {
    return { left: r.left + 'px', top: r.top + 'px', width: r.width + 'px', height: r.height + 'px', borderRadius: radio };
  }

  function abrir(i) {
    if (fase || !visor.hidden) return;
    volverA = document.activeElement;
    var li = secuencia[i], miniatura = li.querySelector('img');
    var desde = enlace(li).getBoundingClientRect(), radio = getComputedStyle(enlace(li)).borderRadius;
    // Mismo bloqueo de scroll que el modal de habitaciones (app.js).
    scrollY0 = window.scrollY;
    document.body.classList.add('modal-lock');
    document.body.style.top = (-scrollY0) + 'px';
    visor.hidden = false;
    mostrar(i);
    visor.querySelector('.gal-visor-cerrar').focus({ preventScroll: true });
    if (!anima()) { visor.classList.add('on', 'listo'); return; }

    fase = 'abriendo';
    var esta = ++vuelta;
    // Fondo: un círculo que crece desde la esquina opuesta a la foto tocada.
    var cx = desde.left + desde.width / 2 < innerWidth / 2 ? innerWidth : 0;
    var cy = desde.top + desde.height / 2 < innerHeight / 2 ? innerHeight : 0;
    var R = Math.ceil(Math.hypot(innerWidth, innerHeight));
    fondo.style.cssText = 'inset:auto;border-radius:50%;width:' + 2 * R + 'px;height:' + 2 * R + 'px;left:' + (cx - R) + 'px;top:' + (cy - R) + 'px';
    fondo.animate([{ transform: 'scale(0)' }, { transform: 'scale(1)' }], { duration: 400, easing: 'ease', fill: 'both' });
    // La copia vuela de la grilla al lugar de la foto grande.
    clon = crearClon(miniatura.currentSrc || miniatura.src, desde);
    var hasta = vImg.getBoundingClientRect();
    requestAnimationFrame(function () { if (esta === vuelta) visor.classList.add('on'); });
    clon.animate([marco(desde, radio), marco(hasta, '6px')], { duration: 600, easing: CURVA, fill: 'forwards' })
      .finished.then(function () {
        cuandoCargue(vImg, function () {
          if (esta !== vuelta) return;
          visor.classList.add('listo');               // foto grande: fundido de 0,2 s (CSS)
          setTimeout(function () {
            if (esta !== vuelta) return;
            if (clon) { clon.remove(); clon = null; }
            fase = '';
          }, 220);
        });
      }, function () {});
  }

  function cerrar(inmediato) {
    if (visor.hidden || fase === 'cerrando') return;
    // Cerrar mientras la foto todavía vuela: se corta la apertura y se cierra
    // de una (esperar a que aterrice para devolverla se siente trabado).
    if (fase === 'abriendo') inmediato = true;
    var li = secuencia[actual];
    function fin() {
      vuelta++;
      if (clon) { clon.getAnimations().forEach(function (a) { a.cancel(); }); clon.remove(); clon = null; }
      fondo.getAnimations().forEach(function (a) { a.cancel(); });
      fondo.style.cssText = '';
      visor.hidden = true;
      visor.classList.remove('on', 'listo');
      vImg.removeAttribute('src');
      fotos.forEach(function (f) { f.classList.remove('is-abierta'); });
      document.body.classList.remove('modal-lock');
      document.body.style.top = '';
      window.scrollTo({ top: scrollY0, left: 0, behavior: 'instant' });
      // preventScroll: el foco vuelve a la foto sin mover la página (con el
      // scroll-padding del header, focus() a secas la corría ~120px).
      if (volverA && volverA.focus) volverA.focus({ preventScroll: true });
      fase = '';
    }
    if (inmediato === true || !anima() || !li) { fin(); return; }

    fase = 'cerrando';
    var desde = vImg.getBoundingClientRect(), hasta = enlace(li).getBoundingClientRect();
    var radio = getComputedStyle(enlace(li)).borderRadius;
    clon = crearClon(vImg.currentSrc || vImg.src, desde);
    clon.querySelector('img').style.objectFit = 'cover';
    visor.classList.remove('on', 'listo');
    fondo.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, easing: 'ease-out', fill: 'forwards' });
    var aLaVista = hasta.width > 0 && hasta.bottom > 0 && hasta.top < innerHeight;
    if (!aLaVista) {
      clon.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' }).finished.then(fin);
      return;
    }
    clon.animate([marco(desde, '6px'), marco(hasta, radio)], { duration: 300, easing: 'ease', fill: 'forwards' })
      .finished.then(function () {
        li.classList.remove('is-abierta');            // la foto vuelve a su hueco
        setTimeout(function () {
          clon.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, fill: 'forwards' }).finished.then(fin);
        }, 60);
      });
  }

  if (visor) {
    pagina.addEventListener('click', function (e) {
      var a = e.target.closest('.gal-link');
      if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button) return;   // abrir en pestaña nueva sigue andando
      e.preventDefault();
      abrir(secuencia.indexOf(a.closest('.gal-item')));
    });
    visor.querySelector('.gal-visor-cerrar').addEventListener('click', function () { cerrar(); });
    visor.querySelector('.gal-visor-prev').addEventListener('click', function () { mostrar(actual - 1); });
    visor.querySelector('.gal-visor-next').addEventListener('click', function () { mostrar(actual + 1); });
    // Tocar el fondo (fuera de la foto y los botones) cierra, como en la referencia.
    visor.addEventListener('click', function (e) {
      if (e.target === visor || e.target === fondo || e.target === vFig) cerrar();
    });
    document.addEventListener('keydown', function (e) {
      if (visor.hidden) return;
      if (e.key === 'Escape') cerrar();
      else if (e.key === 'ArrowRight') mostrar(actual + 1);
      else if (e.key === 'ArrowLeft') mostrar(actual - 1);
      else if (e.key === 'Tab') {
        // El foco no sale del visor mientras está abierto.
        var bs = [].slice.call(visor.querySelectorAll('button'));
        var k = bs.indexOf(document.activeElement);
        if (e.shiftKey ? k <= 0 : k === bs.length - 1) {
          e.preventDefault();
          bs[e.shiftKey ? bs.length - 1 : 0].focus();
        }
      }
    });
    // Deslizar en el celular: más de 50px en horizontal pasa de foto.
    var x0 = null, y0 = null;
    visor.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    visor.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) mostrar(actual + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    // Al cambiar de idioma, el pie del visor (i18n ya tradujo los alt).
    document.addEventListener('i18n:change', function () { if (!visor.hidden) mostrar(actual); });
    // Navegar con el visor abierto (atrás del navegador) lo cierra, sin animar.
    addEventListener('hashchange', function () { cerrar(true); });
    addEventListener('resize', function () { if (!visor.hidden) medir(); }, { passive: true });
  }

  aplicar();
})();
